<template>
  <div class="quiz-result">
    <h3 class="mb-3">{{ $t('quiz_result') }}</h3>

    <p>
      {{ $t('quiz_result_header') }}<br />
      <span class="font-bold color-black mt-3 d-inline-block group-name">
      {{ scoring[this.winnerIndex].groupName }}
    </span>
    </p>
    <p>
      <tradycyjni-europejczycy v-if="scoring[this.winnerIndex].groupIndex === 1">
      </tradycyjni-europejczycy>

      <kanapowi-buntownicy v-if="scoring[this.winnerIndex].groupIndex === 2"></kanapowi-buntownicy>

      <norm-holderzy v-if="scoring[this.winnerIndex].groupIndex === 3"></norm-holderzy>

      <wierni-ojczyznie v-if="scoring[this.winnerIndex].groupIndex === 4"></wierni-ojczyznie>

      <dizajnerzy-zycia v-if="scoring[this.winnerIndex].groupIndex === 5"></dizajnerzy-zycia>

      <wypedzani-z-raju v-if="scoring[this.winnerIndex].groupIndex === 6"></wypedzani-z-raju>
    </p>
    <p class="social-section">
      <span class="separator mb-2"></span>
      <span class="email-info">
      Podaj swój adres e-mail, żeby przesłać na skrzynkę wyniki Quizu.
    </span>

    <send-email :targetTemplate="scoring[this.winnerIndex].htmlTemplateFilenameBase"></send-email>
      <br/>

    <span class="separator mb-2"></span>
    <span class="email-info">
      Udostępnij stronę na:
      <span class="social-share-btn">
        <ShareNetwork network="facebook" :url="`${quiz.basicPortalUrl
          }/social/${scoring[this.winnerIndex].htmlTemplateFilenameBase}.php`"
                      :title="`Młodzi Dorośli - Quiz: ${scoring[this.winnerIndex].groupName}`"
                      :popup="{width: 500, height: 400}">
          Facebook
        </ShareNetwork>
      </span>

      <span class="social-share-btn">
        <ShareNetwork network="twitter"
                      :url="`${quiz.basicPortalUrl
          }/social/${scoring[this.winnerIndex].htmlTemplateFilenameBase}.php`"
                      :title="`Młodzi Dorośli - Quiz: ${scoring[this.winnerIndex].groupName}`"
                      :popup="{width: 500, height: 400}">
          Twitter
        </ShareNetwork>
      </span>
    </span>
    </p>
  </div>
</template>

<script>
import TradycyjniEuropejczycy from '@/views/results/TradycyjniEuropejczycy';
import KanapowiBuntownicy from '@/views/results/KanapowiBuntownicy';
import NormHolderzy from '@/views/results/NormHolderzy';
import WierniOjczyznie from '@/views/results/WierniOjczyznie';
import DizajnerzyZycia from '@/views/results/DizajnerzyZycia';
import WypedzaniZRaju from '@/views/results/WypedzaniZRaju';
import SendEmail from '@/views/parts/SendEmail';

export default {
  name: 'Result',
  props: ['questions', 'scoring'],
  components: {
    TradycyjniEuropejczycy,
    KanapowiBuntownicy,
    NormHolderzy,
    WierniOjczyznie,
    DizajnerzyZycia,
    WypedzaniZRaju,
    SendEmail,
  },
  created() {
    // this.calculateResult();
    this.calculateScoringResults();
  },
  data() {
    return {
      correctCount: 0,
      score: 100.0,
      calculatedScoring: [],
      winnerIndex: null,
      quiz: window.Quiz,
    };
  },
  methods: {
    calculateResult() {
      this.questions.forEach((item, index) => {
        if (item.isCorrect) {
          this.correctCount += 1;
        }
      });

      this.score = ((this.correctCount / this.questions.length) * 100).toFixed(2);
    },
    calculateScoringResults() {
      if (!window.Quiz.testModeWinner) {
        // Normal behaviour
        this.questions.forEach((item, index) => {
          this.scoring.forEach((group, indexGroup) => {
            if (!this.calculatedScoring[indexGroup]) {
              this.calculatedScoring[indexGroup] = 0;
            }

            const optionScore = item.answers[item.answer].score;
            this.calculatedScoring[indexGroup] += (optionScore * group.scoreWeights[index]);
          });
        });

        // add SCORING CONSTANT to each result
        this.calculatedScoring.forEach((value, index) => {
          this.calculatedScoring[index] += this.scoring[index].scoringConstant;
        });

        // find the biggest value
        let winnerValue = -99999;
        this.calculatedScoring.forEach((value, index) => {
          // console.log('group:', index, 'calculatedScoring:', value);
          if (value > winnerValue) {
            winnerValue = value;
            this.winnerIndex = index;
          }
        });
      } else {
        // Test Mode Behaviour
        this.winnerIndex = window.Quiz.testModeWinner - 1;
      }
    },
  },
};
</script>

<style scoped>
.quiz-answer {
  padding: 3px 5px;
  margin: 3px 0;
  cursor: pointer;
}

.correct-answer {
  border: 1px solid #36bf42;
}

.wrong-answer {
  border: 1px solid #ef251c;
}

.group-name {
  font-size: 2em;
}
</style>

<style>
.icon {
  width: 100px;
}

.cechy {
  flex-wrap: nowrap;
}

.images {
  padding-right: 1em;
}

.description-col {
  flex-grow: 1;
}

.separator {
  border-top: 1px solid #aaaaaa;
  display: block;
  width: 100%;
}

.email-info {
  margin: 1em 0 1.3em;
  display: block;
}

.social-section {
  padding-left: 298px;
}
.social-share-btn {
  margin: 1em;
}

@media screen and (max-width: 960px) {
  .cechy {
    flex-wrap: wrap;
  }

  .social-section {
    padding-left: 0;
  }
}
</style>
